<template>
<div class="flex flex-col items-center">
    <h4 class="font-medium text-lg text-primary">Loading</h4>
    <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
    <h4 class="">{{message}}</h4>
</div>
</template>

<script setup="props">
import { defineProps } from "vue";

defineProps({
    message: {
        type: String,
        default: "Just loading"
    }
})
</script>
